import Vue from 'vue'
import store from '../store'

function normalizeList(value) {
  if (!value) return []
  return Array.isArray(value) ? value.filter(Boolean) : [value]
}

function resolveRequirement(value) {
  if (!value) {
    return { roles: [], permissions: [] }
  }
  if (typeof value === 'object' && !Array.isArray(value)) {
    return {
      roles: normalizeList(value.roles),
      permissions: normalizeList(value.permissions)
    }
  }
  const mixed = normalizeList(value)
  return {
    roles: mixed,
    permissions: mixed
  }
}

function hasAuthority(requirement) {
  const roleCodes = (store.state.userInfo && store.state.userInfo.roleCodes) || []
  const permissions = (store.state.userInfo && store.state.userInfo.permissions) || []
  const roleOk = !requirement.roles.length || requirement.roles.some(item => roleCodes.includes(item))
  const permissionOk = !requirement.permissions.length || requirement.permissions.some(item => permissions.includes(item))
  return roleOk || permissionOk
}

function toggleElement(el, visible) {
  if (!el) return
  el.style.display = visible ? '' : 'none'
}

// v-permission="['OFFICE','ADMIN']"
// v-permission="['SYSTEM_USER_CREATE']"
// v-permission="{ permissions: ['SYSTEM_USER_CREATE'], roles: ['ADMIN'] }"
Vue.directive('permission', {
  inserted(el, binding) {
    toggleElement(el, hasAuthority(resolveRequirement(binding.value)))
  },
  update(el, binding) {
    toggleElement(el, hasAuthority(resolveRequirement(binding.value)))
  }
})

